import React from 'react';
import useQuery from '../../utilities/use-query';
import {useLocation, useNavigate} from 'react-router-dom';
import {useOperatorDispatch} from './operator-interface';
import searchFilter from '../../utilities/search-filter';
import {useSettingsState} from '../settings';

const Start = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const location = useLocation();
    const dispatch = useOperatorDispatch();
    const navigate = useNavigate();
    React.useEffect(() => {
        dispatch({type: 'start', payload: {serviceId}});
        navigate(`/operator-interface/step-2${searchFilter(location.search)}`, {replace: true});
    });
    return (
        <></>
    );
};

export default React.memo(Start);